import React from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { LoanApi, LoanPreviewMode } from "../../../../../services/Api/types";
import { selectPartner } from "../../../../../services/partner/selectors";
import CancelLoanModal from "../CancelLoanModal";
import LoanPreviewAlerts from "./LoanPreviewAlerts";
import LoanPreviewAttachmentsCard from "./LoanPreviewAttachmentsCard";
import LoanPreviewBasicInfoCard from "./LoanPreviewBasicInfoCard";
import LoanPreviewItemsCard from "./LoanPreviewItemsCard";

interface Props {
	loan: LoanApi;
	handleUpdateLoan: (data: LoanApi) => void;
	mode?: LoanPreviewMode;
	setShowCancelLoanModal?: (value: boolean) => void;
	showCancelLoanModal?: boolean;
	onFetchLoan?: () => void;
	admin?: boolean;
}

const LoanPreview = ({
	loan,
	mode,
	handleUpdateLoan,
	setShowCancelLoanModal,
	showCancelLoanModal,
	onFetchLoan,
	admin,
}: Props) => {
	const partner = useSelector(selectPartner);
	const form = useForm<LoanApi>({
		defaultValues: loan,
	});
	const { reset } = form;

	const onHideCancelLoanModal = () => {
		if (setShowCancelLoanModal) setShowCancelLoanModal(false);
	};

	const onSuccessCloseLoan = (data: LoanApi) => {
		reset({
			attachments: [...data.attachments],
		});
		handleUpdateLoan(data);
	};

	const onSuccessGenerateTerminationFile = () => {
		if (onFetchLoan) onFetchLoan();
	};

	return (
		<>
			<LoanPreviewAlerts loan={loan} mode={mode} />
			<LoanPreviewBasicInfoCard loan={loan} admin={admin} />
			<LoanPreviewItemsCard loan={loan} />
			<LoanPreviewAttachmentsCard loan={loan} form={form} handleUpdateLoan={handleUpdateLoan} />
			{showCancelLoanModal && (
				<CancelLoanModal
					onHide={onHideCancelLoanModal}
					isShown={showCancelLoanModal}
					isAdminMode={!partner?.id}
					onSuccessfulCancelAction={onSuccessCloseLoan}
					onSuccessfulGenerateAction={onSuccessGenerateTerminationFile}
					loan={loan}
					partnerId={partner?.id}
				/>
			)}
		</>
	);
};
export default LoanPreview;
